"use client"

import { useQuery } from "@tanstack/react-query"
import {
  listKnowledgeBaseFoldersAction,
  type KnowledgeBaseFoldersResult,
} from "@/server-actions/knowledge-base-folders"
import { useAuth } from "@/hooks/use-auth"
import { getKnowledgeBaseFoldersQueryKey } from "@/lib/ai/knowledge-base/query-keys"

export function useKnowledgeBaseFoldersQuery(options?: {
  enabled?: boolean
}) {
  const { user, isLoading } = useAuth()
  const userId = user?.user_id ?? null
  const activeTenantId =
    user?.impersonated_tenant_id ?? user?.tenant_id ?? null

  return useQuery<KnowledgeBaseFoldersResult>({
    queryKey: getKnowledgeBaseFoldersQueryKey(userId, activeTenantId),
    enabled:
      (options?.enabled ?? true)
      && !isLoading
      && Boolean(userId)
      && Boolean(activeTenantId),
    queryFn: async () => {
      const result = await listKnowledgeBaseFoldersAction({})
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
